import React from 'react'

function About(){
    return(
        <section id="about">
            <h2>Hi there!</h2>
            <p>My name is George Blue.
            I graduated with my bachelors in computer engineering from the University of Kansas in 2023. <br/>
            I currently work for Raytheon as a software engineer. 
            </p>
            <p>Outside of work, you can catch me doing multiple things both indoors and outdoors. <br/>
                Indoors, I like to cook, play video games, read, learn new languages (currently learning Korean) and code.<br/>
                Outdoors I like to climb, mountain bike, hike and backpack.</p>
        </section>
    );
}

export default About;